// extracted by mini-css-extract-plugin
export default {"mCard":"WE-z","image":"XE-z","imageNoBackground":"YE-z","imageHasCategory":"ZE-z","fullWidth":"_E-z"};